import React from 'react';

/**
 * Generate a color class number (1-10) based on chain ID.
 * This matches the logic from the old version to ensure consistent chain colors.
 * Letters A-I map directly (1-9). Other characters are hashed to 1-9.
 */
const colorHashForChainId = (chain: string): number => {
   const char = chain[0];
   const idx = char.charCodeAt(0) - 64;
   if (idx <= 9) {
      return idx;
   } else {
      // Simple hash function for strings
      let hash = 0;
      for (let i = 0; i < chain.length; i++) {
         const charCode = chain.charCodeAt(i);
         hash = (hash << 5) - hash + charCode;
         hash = hash & hash; // Convert to 32-bit integer
      }
      return (Math.abs(hash) % 9) + 1;
   }
};

/** Renders a single chain ID badge with a consistent CSS color class derived from the chain letter. */
const render_chain_id = (chain_id: string): React.JSX.Element => {
   const colorClass = `ccolor${colorHashForChainId(chain_id)}`;
   return <span className={`chain-id ${colorClass}`}>{chain_id}</span>;
};

/** Renders a comma-separated list of chain ID badges. */
const render_chain_ids = (chain_ids: string[]): React.JSX.Element => {
   return (
      <>
         {chain_ids.map((chain_id, index) => (
            <React.Fragment key={chain_id}>
               {render_chain_id(chain_id)}
               {index < chain_ids.length - 1 ? ',' : ''}
            </React.Fragment>
         ))}
      </>
   );
};

/** Renders a human-readable label like "in 3 PDB entries" (or nothing when count is 0). */
const render_num_pdb_entries = (num_entries: number): React.JSX.Element => {
   return (
      <>
         {num_entries > 0 && (
            <>
               in {num_entries} PDB {num_entries === 1 ? 'entry' : 'entries'}
            </>
         )}
      </>
   );
};

export { render_chain_id, render_chain_ids, render_num_pdb_entries };
